// Vacaciones urgentes — habilita a un empleado a cargar una solicitud con menos
// de los 20 días de anticipación que exige el sistema de vacaciones.
//
// RRHH recibe del empleado un código de solicitud (legajo + fecha de inicio),
// lo ve interpretado en pantalla y, si está de acuerdo, genera el código de
// habilitación que el empleado carga junto con su solicitud. La aritmética de
// los dos códigos está en codigos.js; acá solo se adapta al molde de la app.
//
// A diferencia de las otras operaciones, calcular es async (Web Crypto) y no
// hay sucursal. Diseño en docs/plans/2026-09-11-vacaciones-urgente-design.md.

import { AppConfig } from "../../shared/utils/AppConfig.js";
import { fechaIso, generarHabilitacion, parsearSolicitud } from "./codigos.js";

const fechaLegible = (fecha) =>
  fecha.toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" });

export function validar({ solicitud }, hoy = new Date()) {
  if (!AppConfig.vacaciones.secreto) {
    return "Falta configurar el secreto de vacaciones en la app.";
  }
  if (!parsearSolicitud(solicitud, hoy)) {
    return "Código de solicitud incorrecto. Revisá los 10 dígitos.";
  }
  return null;
}

/**
 * Vista previa de lo que se va a habilitar, para que RRHH lo vea antes de
 * generar. Devuelve null mientras el código esté incompleto o sea inválido.
 */
export function interpretar({ solicitud }, hoy = new Date()) {
  const datos = parsearSolicitud(solicitud, hoy);
  if (!datos) return null;
  return `Legajo ${datos.legajo} · inicio ${fechaLegible(datos.fechaInicio)}`;
}

export async function calcular({ solicitud }, hoy = new Date()) {
  const { legajo, fechaInicio } = parsearSolicitud(solicitud, hoy);
  const codigo = await generarHabilitacion(legajo, fechaInicio, hoy, AppConfig.vacaciones.secreto);

  return {
    codigo,
    detalle: {
      legajo,
      fechaInicio: fechaIso(fechaInicio),
    },
  };
}
